import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { UserLoginService } from '../service/aws/user.login.service';

@Component({
  selector: 'app-employee-engagementheader',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  userName: string;

  constructor(
    private router: Router,
    private userLoginService: UserLoginService,
    private cookieService: CookieService ) {}

  ngOnInit() {
    //this.userName = this.cookieService.get('tok');
    this.userName = localStorage.getItem('tok');
  }

  goHome() {
    this.router.navigate(['/']);
  }

  logOut() {
    this.userLoginService.logout();
  }
}
